import { ApiUserConstants } from "../../../shared/constants/api-constants/api-user.constants";
export class DisclaimerDialogBodyConstants {
    static ACCEPT_DISCLAIMER_URL = ApiUserConstants.URL + "/" + ApiUserConstants.FUNCTION_ACCEPT_DISCLAIMER;
    static ACCEPT_DISCLAIMER_TEXT = "Accept disclaimer";
    static ACCEPT_DISCLAIMER_BUSY_SPINNER = "acceptDisclaimer";
}
